mutation DeleteNewsItem($id: ID!) {
  deleteNewsItem(input: { id: $id }) {
    success
  }
}
